import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../auth/AuthProvider';
import { useNavFlags } from '../features/pos/navFlags';
import { MenuOffPage } from './MenuOffPage';
import { isMenuOff, menuOfPath, visibleNav } from './nav';

/** Where to land when a menu is off: the first menu the user still has. */
export function useMenuHome(): string | null {
  const { can } = useAuth();
  return visibleNav((k) => can(k), useNavFlags())[0]?.items[0]?.path ?? null;
}

/**
 * The page, unless it belongs to a menu PackBytes turned off for this shop: then a notice (or,
 * for the dashboard, the first menu still on). Links and typed URLs land here too.
 */
export function MenuGuard() {
  const { pathname } = useLocation();
  const { me } = useAuth();
  const home = useMenuHome();
  const item = menuOfPath(pathname);
  if (!item || !isMenuOff(me, item.key)) return <Outlet />;
  if (pathname === '/' && home) return <Navigate to={home} replace />;
  return <MenuOffPage item={item} home={home} />;
}
